interface PhoenixSocketConfig {
  url: string;
}

const getPhoenixSocketConfig = (): PhoenixSocketConfig => {
  const appEnv = process.env.NEXT_PUBLIC_NODE_ENV;

  // Allow override via environment variable
  if (process.env.NEXT_PUBLIC_PHOENIX_SOCKET_URL) {
    return { url: process.env.NEXT_PUBLIC_PHOENIX_SOCKET_URL };
  }

  // Derive WebSocket URL from realtime service URL if set
  if (process.env.NEXT_PUBLIC_REALTIME_URL) {
    const realtimeUrl = process.env.NEXT_PUBLIC_REALTIME_URL;
    const wsUrl =
      realtimeUrl
        .replace(/^https:/, 'wss:')
        .replace(/^http:/, 'ws:')
        .replace(/\/$/, '') + '/socket';
    return { url: wsUrl };
  }

  if (appEnv === 'staging') {
    return { url: 'wss://realtime.lingualbox.jp/socket' };
  } else if (appEnv === 'prod') {
    return { url: 'wss://realtime.lingualbox.com/socket' };
  }

  // Development - lb_realtime runs on port 4000
  return { url: 'ws://localhost:4000/socket' };
};

export default getPhoenixSocketConfig;
